import { IconName } from '@ui/elements/Icon'

export const getVariableIcon = (v: string): IconName => {
  if (v.includes('deal')) return 'star'
  if (v.includes('frame')) return 'eye-glass2'
  if (v.includes('temple')) return 'ear'
  if (v.includes('upgrade')) return 'diamond'
  if (v.includes('packageUpgrade')) return 'diamond'
  if (v.includes('type')) return 'eye'
  if (v.includes('index')) return 'arrows-vertical'
  if (v.includes('coating')) return 'droplet'
  if (v.includes('filter')) return 'background'
  if (v.includes('tinting')) return 'sun-high'
  if (v.includes('color')) return 'palette'
  if (v.includes('intensity')) return 'brightness-filled'
  if (v.includes('distance')) return 'map-pins'
  if (v.includes('lifestyle')) return 'viewfinder'
  if (v.includes('far')) return 'arrows-maximize'
  if (v.includes('near')) return 'arrows-minimize'
  if (v.includes('insurance')) return 'shield-half'
  if (v.includes('lens')) return 'eye'
  if (v.includes('corridor')) return 'cross-hair'
  if (v.includes('mirror')) return 'flip-vertical'
  return 'default'
}
